document.addEventListener('DOMContentLoaded', () => {
  // Delegate click handling for any add-to-cart buttons in product cards
  document.body.addEventListener('submit', (e) => {
    const form = e.target.closest('.boxed-card__form');
    if (!form) return;

    const btn = form.querySelector('.boxed-card__btn');
    if (!btn) return;

    const originalText = btn.textContent.trim();
    btn.textContent = 'Added!';
    btn.disabled = true;

    // Revert after 1.5 seconds
    setTimeout(() => {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 1500);
  });
});
